// How many list filters differ from their defaults — the number "Reset
// filters" shows. Search text is compared as typed: the lists filter on the
// raw text, so even a search of only spaces narrows them and must count.
export function countActiveFilters(filters, defaults) {
  return Object.keys(defaults).filter((key) => filters[key] !== defaults[key])
    .length;
}
